import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const poolCouponRowInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("pool-coupon-row").default("pool-coupon-row"),
      selectedColumnIndex: z.number().nullable().default(null)
    }),
    shouldValidate: () => true,
    validate: (node, entry) => node.validation.correctColumnIndex === entry.selectedColumnIndex,
    parseLegacyDetailItem: (item, context) => {
      if (["SelectAnswers"].includes(context.relatedTask.taskType) && ["PoolCoupon"].includes(context.relatedTask.answerType ?? "") && typeof item === "number") {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "pool-coupon-row",
          selectedColumnIndex: item
        }];
      }
    }
  },
  schema: z.object({
    text: z.string(),
    correctAnswer: z.number()
  }),
  postprocessSchemaInput: ({
    correctAnswer,
    ...input
  }, context) => {
    return {
      ...input,
      id: `${context.taskId}-${context.index}`,
      nodeType: "pool-coupon-row-input",
      validation: {
        correctColumnIndex: correctAnswer
      }
    };
  }
});

export { poolCouponRowInput };
//# sourceMappingURL=input.row.js.map
